(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afflp2-products"]) return;
  try {
    
$(document).ready(function(){ 
    $('.dad-boxes-carousel').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1170,
          settings: {  
            centerMode: true,
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            centerPadding: '20px'
          }
        }
      ]  
    });
    $('.dad-box-el').on('click',function(){
      $('.dad-box-el').removeClass('active');
      let slideIndex = $(this).data('slide');
      console.log(slideIndex);
      $(this).addClass('active');
      $('.dad-boxes-carousel').slick('slickGoTo',parseInt(slideIndex));
  });
  $('.dad-boxes-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.dad-box-el').removeClass('active');
    $('.dad-box-el[data-slide="'+nextSlide+'"').addClass('active');
});  
    $('.select_box').on('click',function(e){
      e.preventDefault();
      $('html, body').animate({scrollTop: $('.dad-box-form').offset().top }, 2000);
  });
  $('.dad-box__image-thumbs img').on('click',function() {
    let mainImage = $(this).attr('id').replace('thumb','main');
    $(this).parents('.dad-box-product').find('.main-image').addClass('visually-hidden');
    $('#'+mainImage).removeClass('visually-hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["challenge-product"]) return;
  try {
    
$(document).ready(function(){ 
  $('.challenge-spf-carousel').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          arrows: false,
          dots:true
        }
      }
    ]  
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dad-boxes-products-new"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
      $('.dad-boxes-carousel').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1170,
          settings: {  
            centerMode: true,
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            centerPadding: '20px'
          }
        }
      ]  
    });
    $('.dad-box-el').on('click',function(){
      $('.dad-box-el').removeClass('active');
      let slideIndex = $(this).data('slide');
      console.log(slideIndex);
      $(this).addClass('active');
      $('.dad-boxes-carousel').slick('slickGoTo',parseInt(slideIndex));
  });
  $('.dad-boxes-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.dad-box-el').removeClass('active');
    $('.dad-box-el[data-slide="'+nextSlide+'"').addClass('active');
});  
    $('.select_box').on('click',function(e){
      e.preventDefault();
      $('html, body').animate({scrollTop: $('.dad-box-form').offset().top }, 2000);
  });
  $('.dad-box__image-thumbs img').on('click',function() {
    let mainImage = $(this).attr('id').replace('thumb','main');
    $(this).parents('.dad-box-product').find('.main-image').addClass('visually-hidden');
    $('#'+mainImage).removeClass('visually-hidden');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dad-boxes-products"]) return;
  try {
    
$(document).ready(function(){ 
    $('.dad-boxes-carousel').slick({
      infinite: true,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1170,
          settings: {  
            centerMode: true,
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            centerPadding: '20px'
          }
        }
      ]  
    });
    $('.dad-box-el').on('click',function(){
      $('.dad-box-el').removeClass('active');
      let slideIndex = $(this).data('slide');
      console.log(slideIndex);
      $(this).addClass('active');
      $('.dad-boxes-carousel').slick('slickGoTo',parseInt(slideIndex));
  });
  $('.dad-boxes-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.dad-box-el').removeClass('active');
    $('.dad-box-el[data-slide="'+nextSlide+'"').addClass('active');
});  
    $('.select_box').on('click',function(e){
      e.preventDefault();
      $('html, body').animate({scrollTop: $('.dad-box-form').offset().top }, 2000);
  });
  $('.dad-box__image-thumbs img').on('click',function() {
    let mainImage = $(this).attr('id').replace('thumb','main');
    $(this).parents('.dad-box-product').find('.main-image').addClass('visually-hidden');
    $('#'+mainImage).removeClass('visually-hidden');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fantasy-spf-product"]) return;
  try {
    
$(document).ready(function(){ 
  $('.spf-carousel').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          arrows: false,
          dots:true
        }
      }
    ]  
  });

  $('.btn-continue, .btn-back').on('click',function(e){
    e.preventDefault();
    var currrentSection = $(this).closest('section').attr("data-step");
    if ($(this).attr("class")=="btn-back"){
        var toNextSection = parseInt(currrentSection)-1;
        var nextSection = '.fore-step-'+toNextSection;
        $('.progressbar li:nth-child('+currrentSection+')').removeClass('active');
    }
    else{
        var toNextSection = parseInt(currrentSection)+1;
        var nextSection = '.fore-step-'+toNextSection;
        $('.progressbar li:nth-child('+toNextSection+')').addClass('active');
    }
    $('section:not('+nextSection+')').removeClass('active');
    $('section'+nextSection).addClass('active');
    /*$([document.documentElement, document.body]).animate({
    scrollTop: $(nextSection).offset().top
    }, 500);*/
}); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-product"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){ 
  $('.product-bestseller-carousel').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          dots:true
        }
      }
    ]  
  });
  $(".arrow-bs.left").click(function(e) {
    e.preventDefault();
    $(".product-bestseller-carousel").slick("slickPrev"); 
  });
  $(".arrow-bs.right").click(function(e) {
    e.preventDefault();
    $(".product-bestseller-carousel").slick("slickNext");
  });    
});

  } catch(e) { console.error(e); }
})();
})();
